(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["feltwhimsy-featured-character"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var initFeltwhimsyCharacterCarousel = function(root) {
      var sections = root.matches && root.matches('[data-feltwhimsy-character-carousel]')
        ? [root]
        : root.querySelectorAll('[data-feltwhimsy-character-carousel]');

      Array.prototype.forEach.call(sections, function(section) {
        var items = Array.prototype.slice.call(section.querySelectorAll('[data-character-item]'));
        var details = Array.prototype.slice.call(section.querySelectorAll('[data-character-detail]'));
        var stage = section.querySelector('[data-character-stage]');
        var previousButton = section.querySelector('[data-character-prev]');
        var nextButton = section.querySelector('[data-character-next]');
        var activeIndex = items.findIndex(function(item) { return item.getAttribute('aria-pressed') === 'true'; });
        var gestureStart = null;
        var suppressClick = false;

        if (!items.length) return;
        if (activeIndex < 0) activeIndex = 0;

        var setActiveItem = function(nextIndex) {
          activeIndex = (nextIndex + items.length) % items.length;

          items.forEach(function(item, index) {
            var offset = index - activeIndex;

            if (offset > 2) {
              offset -= items.length;
            } else if (offset < -2) {
              offset += items.length;
            }

            item.classList.remove(
              'feltwhimsy-featured-character__item--offset--2',
              'feltwhimsy-featured-character__item--offset--1',
              'feltwhimsy-featured-character__item--offset-0',
              'feltwhimsy-featured-character__item--offset-1',
              'feltwhimsy-featured-character__item--offset-2',
              'feltwhimsy-featured-character__item--active',
              'feltwhimsy-featured-character__item--offstage'
            );

            item.classList.add('feltwhimsy-featured-character__item--offset-' + offset);
            item.classList.toggle('feltwhimsy-featured-character__item--active', offset === 0);
            item.classList.toggle('feltwhimsy-featured-character__item--offstage', offset < -2 || offset > 2);
            item.setAttribute('aria-pressed', offset === 0 ? 'true' : 'false');
          });

          details.forEach(function(detail, index) {
            detail.hidden = index !== activeIndex;
          });
        };

        items.forEach(function(item, index) {
          item.addEventListener('click', function(event) {
            if (suppressClick) {
              event.preventDefault();
              return;
            }
            setActiveItem(index);
          });
        });

        if (stage && window.PointerEvent) {
          stage.addEventListener('pointerdown', function(event) {
            if (!window.matchMedia('(max-width: 749px)').matches || event.pointerType === 'mouse') return;

            gestureStart = {
              id: event.pointerId,
              x: event.clientX,
              y: event.clientY
            };
          });

          stage.addEventListener('pointerup', function(event) {
            if (!gestureStart || gestureStart.id !== event.pointerId) return;

            var deltaX = event.clientX - gestureStart.x;
            var deltaY = event.clientY - gestureStart.y;
            var swipeThreshold = Math.max(36, stage.clientWidth * 0.1);
            gestureStart = null;

            if (Math.abs(deltaX) < swipeThreshold || Math.abs(deltaX) <= Math.abs(deltaY) * 1.15) return;

            suppressClick = true;
            setActiveItem(activeIndex + (deltaX < 0 ? 1 : -1));
            window.setTimeout(function() { suppressClick = false; }, 300);
          });

          stage.addEventListener('pointercancel', function() {
            gestureStart = null;
          });
        }

        if (previousButton) previousButton.addEventListener('click', function() { setActiveItem(activeIndex - 1); });
        if (nextButton) nextButton.addEventListener('click', function() { setActiveItem(activeIndex + 1); });
      });
    };

    initFeltwhimsyCharacterCarousel(document);

    document.addEventListener('shopify:section:load', function(event) {
      initFeltwhimsyCharacterCarousel(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feltwhimsy-shop-by-intent"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initCollectorCarousel(root) {
      var sections = root.matches && root.matches('[data-collector-carousel]') ? [root] : root.querySelectorAll('[data-collector-carousel]');
      Array.prototype.forEach.call(sections, function(section) {
        var slides = Array.prototype.slice.call(section.querySelectorAll('[data-collector-slide]'));
        var previousButton = section.querySelector('[data-collector-previous]');
        var nextButton = section.querySelector('[data-collector-next]');
        var carousel = section.querySelector('.feltwhimsy-shop-by-intent__carousel');
        var activeIndex = 0;
        if (slides.length < 2) return;
        if (slides.length === 2) {
          slides.forEach(function(slide) {
            slide.classList.add('is-active');
            slide.setAttribute('aria-current', 'false');
            slide.tabIndex = 0;
          });
          return;
        }
        function setActive(index) {
          activeIndex = (index + slides.length) % slides.length;
          var previousIndex = (activeIndex - 1 + slides.length) % slides.length;
          var nextIndex = (activeIndex + 1) % slides.length;
          slides.forEach(function(slide, slideIndex) {
            var isActive = slideIndex === activeIndex;
            slide.classList.toggle('is-active', isActive);
            slide.classList.toggle('is-previous', slideIndex === previousIndex);
            slide.classList.toggle('is-next', slideIndex === nextIndex);
            slide.setAttribute('aria-current', isActive ? 'true' : 'false');
            slide.tabIndex = isActive ? 0 : -1;
          });
        }
        previousButton.addEventListener('click', function() { setActive(activeIndex - 1); });
        nextButton.addEventListener('click', function() { setActive(activeIndex + 1); });
        carousel.addEventListener('keydown', function(event) {
          if (event.key === 'ArrowLeft') { event.preventDefault(); setActive(activeIndex - 1); }
          if (event.key === 'ArrowRight') { event.preventDefault(); setActive(activeIndex + 1); }
        });
        setActive(activeIndex);
      });
    }
    initCollectorCarousel(document);
    document.addEventListener('shopify:section:load', function(event) { initCollectorCarousel(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feltwhimsy-trust-strip"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var mobileQuery = window.matchMedia('(max-width: 549px)');
    var reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

    var initTrustCarousel = function(root) {
      var sections = root.matches && root.matches('[data-feltwhimsy-trust-carousel]')
        ? [root]
        : root.querySelectorAll('[data-feltwhimsy-trust-carousel]');

      Array.prototype.forEach.call(sections, function(section) {
        if (section.dataset.trustCarouselInitialized === 'true') return;

        var track = section.querySelector('[data-trust-track]');
        var items = Array.prototype.slice.call(section.querySelectorAll('.feltwhimsy-trust-strip__item'));
        var dots = Array.prototype.slice.call(section.querySelectorAll('[data-trust-dot]'));
        var activeIndex = 0;
        var autoplayTimer = null;
        var scrollTimer = null;

        if (!track || items.length < 2) return;
        section.dataset.trustCarouselInitialized = 'true';

        var updateDots = function(index) {
          activeIndex = index;
          dots.forEach(function(dot, dotIndex) {
            dot.setAttribute('aria-current', dotIndex === activeIndex ? 'true' : 'false');
          });
        };

        var goTo = function(index, behavior) {
          var nextIndex = (index + items.length) % items.length;
          track.scrollTo({ left: items[nextIndex].offsetLeft, behavior: behavior || 'smooth' });
          updateDots(nextIndex);
        };

        var stopAutoplay = function() {
          if (autoplayTimer) window.clearInterval(autoplayTimer);
          autoplayTimer = null;
        };

        var startAutoplay = function() {
          stopAutoplay();
          if (!mobileQuery.matches || reducedMotionQuery.matches || document.hidden) return;
          autoplayTimer = window.setInterval(function() {
            goTo(activeIndex + 1, 'smooth');
          }, 3500);
        };

        dots.forEach(function(dot) {
          dot.addEventListener('click', function() {
            goTo(Number(dot.dataset.trustIndex), 'smooth');
            startAutoplay();
          });
        });

        track.addEventListener('scroll', function() {
          window.clearTimeout(scrollTimer);
          scrollTimer = window.setTimeout(function() {
            var trackCenter = track.scrollLeft + track.clientWidth / 2;
            var closestIndex = 0;
            var closestDistance = Infinity;

            items.forEach(function(item, index) {
              var itemCenter = item.offsetLeft + item.offsetWidth / 2;
              var distance = Math.abs(itemCenter - trackCenter);
              if (distance < closestDistance) {
                closestDistance = distance;
                closestIndex = index;
              }
            });

            updateDots(closestIndex);
          }, 80);
        }, { passive: true });

        track.addEventListener('pointerdown', stopAutoplay);
        track.addEventListener('pointerup', startAutoplay);
        track.addEventListener('pointercancel', startAutoplay);
        section.addEventListener('focusin', stopAutoplay);
        section.addEventListener('focusout', startAutoplay);
        document.addEventListener('visibilitychange', startAutoplay);
        mobileQuery.addEventListener('change', startAutoplay);
        reducedMotionQuery.addEventListener('change', startAutoplay);

        startAutoplay();
      });
    };

    initTrustCarousel(document);
    document.addEventListener('shopify:section:load', function(event) {
      initTrustCarousel(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
